import React from 'react';
import loadable from '@loadable/component';

import FooterLinks from './footer-links';
import { Helpers } from '../../../core/src/helpers';
import { useIsPrivateStore } from '../../../hooks/useUserData';

import './new-header-style.less';

const Header = loadable(() => Helpers.retryFunc(() => import('./header')), {
    ssr: false,
});

const HeaderWrapper = () => {
    const isPrivateStore = useIsPrivateStore();
    if (!isPrivateStore) {
        return null;
    }

    return (
        <React.Fragment>
            <header>
                <Header variation="hawksearch" />
            </header>
        </React.Fragment>
    );
};

const withHeaderFooter = Component => {
    return class extends React.PureComponent {
        render() {
            return (
                <React.Fragment>
                    <HeaderWrapper />
                    <main>
                        <Component {...this.state} {...this.props} />
                    </main>
                    <FooterLinks />
                </React.Fragment>
            );
        }
    };
};

export { Header, withHeaderFooter };
